import faker from 'faker';

const states = [
  { uf: 'AC', state: 'Acre' },
  { uf: 'AL', state: 'Alagoas' },
  { uf: 'AP', state: 'Amapá' },
  { uf: 'AM', state: 'Amazonas' },
  { uf: 'BA', state: 'Bahia' },
  { uf: 'CE', state: 'Ceará' },
  { uf: 'DF', state: 'Distrito Federal' },
  { uf: 'ES', state: 'Espírito Santo' },
  { uf: 'GO', state: 'Goiás' },
  { uf: 'MA', state: 'Maranhão' },
  { uf: 'MT', state: 'Mato Grosso' },
  { uf: 'MS', state: 'Mato Grosso do Sul' },
  { uf: 'MG', state: 'Minas Gerais' },
  { uf: 'PA', state: 'Pará' },
  { uf: 'PB', state: 'Paraíba' },
  { uf: 'PR', state: 'Paraná' },
  { uf: 'PE', state: 'Pernambuco' },
  { uf: 'PI', state: 'Piauí' },
  { uf: 'RJ', state: 'Rio de Janeiro' },
  { uf: 'RN', state: 'Rio Grande do Norte' },
  { uf: 'RS', state: 'Rio Grande do Sul' },
  { uf: 'RO', state: 'Rondônia' },
  { uf: 'RR', state: 'Roraima' },
  { uf: 'SC', state: 'Santa Catarina' },
  { uf: 'SP', state: 'São Paulo' },
  { uf: 'SE', state: 'Sergipe' },
  { uf: 'TO', state: 'Tocantins' },
];

const mockStates = states.map((item) => {
  return {
    uf: item.uf,
    state: item.state,
    cases: faker.datatype.number(),
    deaths: faker.datatype.number(),
    suspects: faker.datatype.number(),
    refuses: faker.datatype.number(),
  };
});

export default mockStates;
